import Debug from 'debug'
import * as Api from '@/app/interaction/api'
import { QuestionInteractionState } from './question-interaction-state'

const debug = Debug('question-interaction-state-chooser-plugin')

export class QuestionInteractionStateChooserPlugin
 implements Api.InteractionStateChooserPlugin<QuestionInteractionState> {

   choose(local: QuestionInteractionState, remote: QuestionInteractionState): "use-local" | "use-remote" {

     debug('choose', local, remote)

     if (local.answer === null && remote.answer !== null) {
       debug('there is no local answer but has remote, use remote')
       return 'use-remote'
     }

     return 'use-local'
  }

    
}
